<template>
	<div>
		<modalconfirm ref="modalconfirmAddRetail" @action="proccessRetail"/>
		<ModalAddSerial ref="ModalAddSerial" :serial_type="serial_type" :name="product_name" :quantity="quantity" @scanLink="scanLink" @saveSerial="saveSerial"/>
		<div class="text-h5">Tambah Penjualan Langsung</div>
		<v-card class="mt-3" outlined>
			<v-form ref="formSR" role="form" v-on:submit.prevent="addRetail">
				<v-card-text class="pt-2">
					<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
						{{alert.message}}
					</v-alert>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-row>
								<v-col cols="8" class="py-0">
									<v-autocomplete v-model="customer_search_value" :loading="isLoading" :items="customerSearchList" :search-input.sync="search" item-text="name" item-value="mid" flat hide-details outlined dense label="Masukan Kode atau Nama Pelanggan" return-object :filter="customFilterCustomer" hide-no-data>
										<template v-slot:item = {item}>
											{{ item.name }} ({{ item.mid }})
										</template>
										<template v-slot:selection = {item}>
											{{ item.name }} ({{ item.mid }})
										</template>
									</v-autocomplete>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-text-field v-model="customer_network_mid" disabled :rules="[inputrules.required]" label="ID Mitra" @focus="() => responseError.network_mid=''" :error-messages="responseError.network_mid" outlined dense @input="toUpper"></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-text-field v-model="customer_mobilephone" @keydown="onlyNumber" disabled label="No. Handphone" @focus="() => responseError.customer_mobilephone=''" :error-messages="responseError.customer_mobilephone" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-currency-field v-model="discount_percentage" label="Diskon (%)" :max="100" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white" @focus="() => responseError.discount_percentage=''" :error-messages="responseError.discount_percentage" :decimalLength="2"></v-currency-field>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-text-field v-model="customer_name" label="Nama" disabled :rules="[inputrules.required]" @focus="() => responseError.customer_name=''" :error-messages="responseError.customer_name" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-textarea v-model="customer_address" label="Alamat" disabled :rules="[inputrules.required]" @focus="() => responseError.customer_address=''" :error-messages="responseError.customer_address" rows="2" height="80" hide-details="auto" outlined dense no-resize></v-textarea>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-text-field v-model="customer_identity" label="No. KTP" disabled :rules="[inputrules.required]" @focus="() => responseError.customer_identity=''" :error-messages="responseError.customer_identity" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-textarea v-model="sr_note" label="Catatan" rows="4" height="80" @focus="() => responseError.note=''" :error-messages="responseError.note" hide-details="auto" outlined dense no-resize></v-textarea>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12">
							<v-alert v-if="responseError.product" color="red lighten-4 pink--text text-body-2">
								<v-icon class="mt-n1" color="pink">mdi-alert-circle-outline</v-icon>
								<span class="pl-2">{{responseError.product}}</span>
							</v-alert>
							<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="25%" class="text-left">Nama Produk</th>
											<th width="10%" class="text-right">Harga Produk (Rp)</th>
											<th width="10%" class="text-left">Jumlah</th>
											<th width="10%" class="text-left">Tipe Serial</th>
											<th width="10%" class="text-left">Serial</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in productsSelected" :key="product.product_id">
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletefromRetail(index)">
															<v-icon dark>mdi-delete</v-icon>
														</v-btn>
													</template>
													<span>Hapus</span>
												</v-tooltip>
											</td>
											<td>
												<v-autocomplete :items="productsNotSelected" :filter="customFilter" return-object item-text="product_name" v-model="product.data" no-data-text="Tidak ada data yang sesuai" :rules="[productRules]" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white" @change="product.data.serial = []">
													<template v-slot:item = {item}>
														{{item.product_code}} - {{item.product_name}} ({{item.product_unit}})
													</template>
													<template v-slot:selection = {item}>
														{{item.product_name}}
													</template>
												</v-autocomplete>
											</td>
											<td class="text-right"> {{ product.data.price ? product.data.price : 0 | toNumber }} </td>
											<td>
												<v-currency-field v-model="product.data.quantity" :rules="[inputrules.required, inputrules.notnull]" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
											</td>
											<td>
												<v-radio-group v-model="product.data.card_type" row v-if="product.data.product_is_serial" @change="product.data.serial = []">
													<v-radio label="Fisik" value="fisik"></v-radio>
													<v-radio label="Digital" value="digital"></v-radio>
												</v-radio-group>
											</td>
											<td>
												<v-tooltip bottom v-if="product.data.product_is_serial && product.data.card_type == 'fisik'">
													<template v-slot:activator="{ on, attrs }">
														<v-btn @click="showModalSerial(product.data)" fab dark x-small depressed color="green darken-1" v-bind="attrs" v-on="on">
															<v-icon dark>mdi-plus</v-icon>
														</v-btn>
													</template>
													<span>Tambah Serial</span>
												</v-tooltip>
											</td>
										</tr>
									</tbody>
									<tfoot v-if="grandTotal > 0">
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Subtotal</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</div>
											</td>
										</tr>
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Total Diskon</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ discountTotal | toRupiah }}</div>
											</td>
										</tr>
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Total Harga</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ grandTotal - discountTotal | toRupiah }}</div>
											</td>
										</tr>
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Potongan Harga</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">
													<v-currency-field v-model="rebate_value" :allow-negative="false" :max="discount_percentage > 100 ? 0 : grandTotal - discountTotal" reverse suffix="Rp " class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
												</div>
											</td>
										</tr>
										<tr>
											<td colspan="4"></td>
											<td colspan="1">
												<div class="font-weight-bold">Total Bayar</div>
											</td>
											<td colspan="1">
												<div class="font-weight-bold text-right">{{ (grandTotal - discountTotal - rebate_value) | toRupiah }}</div>
											</td>
										</tr>
									</tfoot>

								</template>
							</v-simple-table>
						</v-col>
						<v-col cols="12" class="pt-0">
							<v-btn light depressed color="primary" @click="addProduct">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Produk</div>
							</v-btn>
						</v-col>
						<v-col cols="12">
							<v-alert dense text type="error" elevation="0" v-if="responseError.payment">
								<div class="text-body-2">{{responseError.payment}}</div>
							</v-alert>
							<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="30%" class="text-left">Pembayaran</th>
											<th width="20%" class="text-left">Nominal</th>
											<th width="45%" class="text-left">Catatan</th>
											<!-- <th width="30%" class="text-left">Serial</th> -->
										</tr>
									</thead>
									<tbody>
										<tr v-for="(payment, index) in paymentSelected" :key="index">
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletePaymentSO(index)">
															<v-icon dark>mdi-delete</v-icon>
														</v-btn>
													</template>
													<span>Hapus</span>
												</v-tooltip>
											</td>
											<td>
												<v-autocomplete @input="selectPayment($event, index)" :items="paymentsNotSelected" return-object item-text="text" placeholder="Pilih Tipe Pembayaran" no-data-text="Tidak ada data yang sesuai" :rules="[paymentRules]" class="py-2 details-mb-0 width-0" outlined dense hide-details="auto" background-color="white">
												</v-autocomplete>
											</td>
											<td>
												<v-currency-field v-model="payment.data.payment_value" :rules="[inputrules.required]" placeholder="Nominal" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
											</td>
											<td>
												<v-text-field v-model="payment.data.payment_note" placeholder="Catatan" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-text-field>
											</td>
										</tr>
									</tbody>
									<tfoot>
										<tr v-if="productsSelected.length > 0">
											<td colspan="6">
												<div class="d-flex justify-end pt-3">
													<div class="font-weight-bold text-right px-4">Total Dibayarkan</div>
													<div class="font-weight-bold text-right">{{ grandTotalPayment | toRupiah }}</div>
												</div>
											</td>
										</tr>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
						<v-col cols="12" class="pt-0">
							<v-btn light depressed color="primary" @click="addPayment">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Pembayaran</div>
							</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="px-4 pb-4">
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" depressed class="text-capitalize" type="submit">Proses</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'
import ModalAddSerial from '@/views/MLwarehouse/sr/ModalAddSerial'
import _ from 'lodash';

export default {
	inject: ['theme'],
	components: {
		ModalAddSerial
	},
	data() {
		return {
			customer_network_mid: '',
			customer_name: '',
			customer_address: '',
			customer_mobilephone: '',
			customer_email: '',
			customer_identity: '',
			sr_payment: '',
			productsSelected: [],
			paymentSelected: [],
			sr_note: '',
			discount_percentage: 0,
			rebate_value: null,
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
			paymentRules: value => !!value.code || 'Tidak boleh kosong',
			serial_type: [],
			card_type: '',
			product_name: '',
			quantity: 0,
			product_id: '',
			customer_search_value: '',
			isLoading: false,
			customerSearchList: [],
			search: null,
		}
	},
	computed: {
		...mapState('sr', ['listProduct', 'response', 'responseError', 'OptionPaymentMethod', 'alertMultiple', 'customerDetail']),

		paymentsNotSelected() {
			if (this.paymentSelected.length > 0) {
				const paymentSelected = this.paymentSelected.map((el) => el.data)
				return this.OptionPaymentMethod.map((el) => {
					if (paymentSelected.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.OptionPaymentMethod
		},
		grandTotalPayment(){
			let total = 0
			this.paymentSelected.forEach( (el) => {
				let price = el.data.payment_value ? el.data.payment_value : 0
				total += price
			});

			return total
		},
		addressText() {
			var data = []
			if (this.customerDetail.customer_address)
				data.push(this.customerDetail.customer_address)
			if (this.customerDetail.customer_subdistrict_name)
				data.push(this.customerDetail.customer_subdistrict_name)
			if (this.customerDetail.customer_city_name)
				data.push(this.customerDetail.customer_city_name)
			if (this.customerDetail.customer_province_name)
				data.push(this.customerDetail.customer_province_name)
			return data.join(', ')
		},
		productsNotSelected() {
			if (this.productsSelected.length > 0) {
				const selectedProduct = this.productsSelected.map((el) => el.data)
				return this.listProduct.map((el) => {
					if (selectedProduct.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.listProduct
		},
		grandTotal(){
			let total = 0
			this.productsSelected.forEach( (el) => {
				let price = el.data.price ? el.data.price : 0
				let quantity = el.data.quantity ? el.data.quantity : 0
				total += price * quantity
			});

			return total
		},
		discountTotal() {
			return parseInt(this.discount_percentage * this.grandTotal / 100)
		},

	},
	methods: {
		...mapActions('sr', ['createSR', 'getOptionProduct', 'getOptionPaymentMethod', 'detailCustomer', 'scanSerial', 'success', 'scanLinkSerial', 'searchMemberMLM']),
		...mapMutations('sr', ['saveResponse', 'clearDataSR']),
		...mapMutations(['setSnackbar', 'setOverlay']),

		showModalSerial(item) {
			if (item.card_type) {
				this.serial_type = item.product_is_serial
				this.product_id = item.product_id
				this.card_type = item.card_type
				this.product_name = item.product_name
				this.quantity = item.quantity
				this.$refs.ModalAddSerial.showModal()
			}
		},
		scanLink(link) {
			this.scanLinkSerial({
				link: link
			})
      // .then( ({ data }) => {
			// })
		},
		async saveSerial(serial_data) {
      // define index product
			let indexProduct = await this.productsSelected.findIndex(el => el.data.product_id == this.product_id);

      let serialArray = []
			await this.productsSelected.forEach( el => {
        el.data.product_is_serial.forEach(serial=> {
          if (serial.type_id == serial_data.type_id) {
            serialArray = [... serialArray, ... serial.serial_array]
          }
        })
			});
      // find index serial
      // define dataSerial by index serial
      // set total serial needed
      // define serial to save

			await this.scanSerial({
				serial: serial_data.serial,
				type: serial_data.type_id,
				card_type: this.card_type
			}).then((serial) => {
        let serialSuccess = serial.success.filter(el => {
          return !serialArray.includes(el)
        })
        // set product based on index
				let product = this.productsSelected[indexProduct].data

        // find index serial
        let indexSerial = product.product_is_serial.findIndex(el => {
          return el.type_id == serial_data.type_id
        });

        // define dataSerial by index serial
        let dataSerial = product.product_is_serial[indexSerial]

        // set total serial needed
        let serial_needed = product.quantity * serial_data.quantity

				let unique = new Set([... dataSerial.serial_array, ... serialSuccess])
				if (serial_needed >= (dataSerial.serial_array.length + serialSuccess.length)) {
					dataSerial.serial_array = [... unique]
					this.productsSelected[indexProduct].data.product_is_serial[indexSerial].serial_array = dataSerial.serial_array
					this.setSnackbar({
						show: true,
						color: 'success',
						text: `Berhasil scan serial`
					})
				} else {
					if (serialSuccess.length > 0) {
						dataSerial.serial_array = [... unique]
						this.productsSelected[indexProduct].data.product_is_serial[indexSerial].serial_array = dataSerial.serial_array.slice(0, serial_needed)
						this.setSnackbar({
							show: true,
							color: 'red darken-2',
							text: `Serial yang diproses disesuaikan`
						})
					} else {
						this.setSnackbar({
							show: true,
							color: 'red darken-2',
							text: 'Gagal scan serial 2'
						})
					}
				}
				var alert = []
				for (let variable in serial.failed) {
					var msg = '';
					msg += serial.failed[variable].join(', ')
					msg += ` ${variable}`
					alert.push({
						msg: msg,
						show: true
					})
				}
				this.$refs.ModalAddSerial.showMessage(alert)
			}).catch((serial) => {
				var alert = []
				for (let variable in serial.failed) {
					var msg = '';
					msg += serial.failed[variable].join(', ')
					msg += ` ${variable}`
					alert.push({
						msg: msg,
						show: true
					})
				}
				this.$refs.ModalAddSerial.showMessage(alert)
				this.setSnackbar({
					show: true,
					color: 'red darken-2',
					text: 'Gagal scan serial 3'
				})
			})
		},
		customFilter (item, queryText) {
			const textOne = item.product_code.toString().toLowerCase()
			const textTwo = item.product_name.toString().toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		customFilterCustomer (item, queryText) {
			const textOne = item.name.toString().toLowerCase()
			const textTwo = item.mid.toString().toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		toUpper(el) {
			this.customer_network_mid = el.toUpperCase()
		},
		addProduct() {
			this.responseError.product = ''
			this.productsSelected.push({
				data: {
					product_id: '',
					product_name: '',
					quantity: '0',
				},
			})
		},
		deletefromRetail(index){
			this.productsSelected.splice(index, 1)
		},
		addPayment() {
			this.responseError.payment = ''
			this.paymentSelected.push({
				data: {
					code: "",
					text: "",
					payment_note: "",
					payment_value: 0,
				},
			})
		},
		selectPayment(value, index) {
			this.paymentSelected[index].data = Object.assign({}, value)
		},
		deletePaymentSO(index){
			this.paymentSelected.splice(index, 1)
		},
		checkPaymentValue() {
			return new Promise((resolve, reject) => {
				let totalPayment = 0
				this.paymentSelected.forEach( el => {
					if(el.data.payment_value) {
						totalPayment += el.data.payment_value
					}
				})

				let totalProductPrice = 0
				this.productsSelected.forEach( (el) => {
					totalProductPrice += el.data.quantity * el.data.price
				})

				if (totalPayment === (totalProductPrice - this.discountTotal - this.rebate_value)) {
					resolve()
				} else {
					reject()
				}
			});
		},
		addRetail() {
			if (this.$refs.formSR.validate() && this.productsSelected.length > 0) {
				this.checkPaymentValue().then( () => {
					this.$refs.modalconfirmAddRetail.setMessage('Apakah Anda yakin akan memproses transaksi ini?')
					this.$refs.modalconfirmAddRetail.showConfirm()
				}).catch(() => {
					this.setSnackbar({
						show: true,
						color: 'red darken-2',
						text: 'Total pembayaran yang anda masukan tidak sesuai'
					})
				})
			}
		},
		async proccessRetail() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmAddRetail.hideConfirm()
			let product = await this.productsSelected.map( (el) => {
				return {
					product_name: el.data.product_name,
					product_id: el.data.product_id,
					quantity: el.data.quantity,
					price: el.data.price,
					is_serial: el.data.product_is_serial,
					serial: el.data.serial,
					card_type: el.data.card_type
				}
			})
			let payment = await this.paymentSelected.map( el => {
				return {
					payment_name: el.data.text,
					payment_value: el.data.payment_value,
					payment_note: el.data.payment_note,
				}
			})
			let params = await {
				customer_name: this.customer_name,
				customer_address: this.customer_address,
				customer_mobilephone: this.customer_mobilephone,
				customer_email: this.customer_email,
				customer_identity: this.customer_identity,
				network_mid: this.customer_network_mid,
				note: this.sr_note,
				discount_percentage: this.discount_percentage,
				discount_value: this.discountTotal,
				rebate_value: this.rebate_value,
				product: product.map(el => {
          el.is_serial = JSON.stringify(el.is_serial)
          return el
        }),
				payment: payment,
			}
			await this.createSR(params).then(() => {
				if (this.response.code == 200.) {
					this.resetForm()
				}
			})
			await this.setOverlay(false)
			this.$router.go(0)
		},
		resetForm(){
      this.getOptionProduct({limit:100})
			this.saveResponse({})
			this.productsSelected = []
			this.paymentSelected = []
			this.$refs.formSR.resetValidation()
			this.customer_search_value = ''
			this.customer_network_mid = ''
			this.customer_email = ''
			this.customer_identity = ''
			this.sr_payment = ''
			this.sr_note = ''
			this.customer_name = ''
			this.customer_address = ''
			this.customer_mobilephone = ''
			this.discount_percentage = 0
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Penjualan Langsung`)
		this.getOptionProduct({limit:100})
		this.getOptionPaymentMethod()
	},
	beforeDestroy(){
		this.clearDataSR()
	},
	watch: {
		customer_search_value() {
			if (this.customer_search_value) {
				this.customer_network_mid = this.customer_search_value.mid
				this.customer_name = this.customer_search_value.name
				this.customer_mobilephone = '0'+ this.customer_search_value.mobilephone
				this.customer_address = this.customer_search_value.address
				this.customer_email = this.customer_search_value.email
				this.customer_identity = this.customer_search_value.ktp
			} else {
				this.customer_network_mid = ''
				this.customer_name = ''
				this.customer_mobilephone = ''
				this.customer_address = ''
				this.customer_email = ''
				this.customer_identity = ''
			}
		},
		search: {
			handler: _.debounce(function() {
				if (!this.search)
					return
				else if (this.search.length <= 3)
					return

				this.isLoading = true
				this.searchMemberMLM(this.search).then( (val) => {
					this.customerSearchList = val
				}).catch(() => {
					this.customerSearchList = []
				}).finally(() => {
					this.isLoading = false
				})
			}, 700),
		}
	}
}
</script>
